import React from 'react'
import { Button, Form, Input, InputNumber, Radio, Select } from 'antd'

import { INTERNAL_KEY_STATUS_OPTIONS } from '../utils'

import '../styles.css'

const requiredRules = [{
  required: true,
  message: 'This field is required'
}]

const CITIES = ['London', 'Algiers', 'Paris', 'Dubai']

function LockBoxForm (props) {
  const {
    form,
    formName,
    handleCancel,
    handleSubmit,
    editForm,
    properties,
    selectedProperty,
    setSelectedProperty,
    submitButtonLabel,
    propertiesLoading,
    loading
  } = props

  const keyType = Form.useWatch('keyType', form)

  const showUnitsField = React.useMemo(() => {
    if (!selectedProperty) {
      return false
    }

    const groupedPropertyCustomField = selectedProperty?.customFieldValues?.find(item =>
      item?.customField?.name === 'grouped_property'
    )

    return selectedProperty.listingUnits?.length > 1 &&
      groupedPropertyCustomField?.value === 'Yes'
  }, [selectedProperty])

  return (
    <Form
      autoComplete="off"
      form={form}
      layout="vertical"
      name={formName}
      onFinish={handleSubmit}
    >
      <Form.Item
        name="keyType"
        className="!mb-3"
      >
        <Radio.Group
          onChange={e => {
            form.setFieldValue('internalKeyType', undefined)
            if (e.target.value === 'keysProperty') {
              form.setFieldValue('city', undefined)
            } else {
              setSelectedProperty(undefined)
              form.setFieldValue('propertyId', undefined)
              form.setFieldValue('unitId', undefined)
            }
          }}
        >
          <Radio value="keysProperty">Keys Property</Radio>
          <Radio value="otherKeys">Other Keys</Radio>
        </Radio.Group>
      </Form.Item>

      {keyType === 'keysProperty'
        ? (
          <>
            <Form.Item
              name="propertyId"
              label="Property"
              className="!mb-3"
              rules={requiredRules}
            >
              <Select
                loading={propertiesLoading}
                placeholder="Select property"
                optionFilterProp="label"
                options={properties}
                onChange={(_, option) => {
                  setSelectedProperty(option?.data)
                  form.setFieldValue('unitId', undefined)
                }}
                showSearch
                allowClear
              />
            </Form.Item>

            {showUnitsField && (
              <Form.Item
                name="unitId"
                label="Property unit"
                rules={requiredRules}
                className="!mb-3"
              >
                <Select
                  allowClear
                  placeholder="Select Unit"
                  options={selectedProperty.listingUnits.map(unit => ({
                    label: unit.name,
                    value: unit.id
                  }))}
                  className="w-full"
                />
              </Form.Item>
            )}
          </>
        )
        : (
          <Form.Item
            name="city"
            label="City"
            rules={requiredRules}
            className="!mb-3"
          >
            <Select
              allowClear
              placeholder="Select City"
              options={CITIES.map(city => ({
                label: city, value: city
              }))}
              className="w-full"
            />
          </Form.Item>
        )}

      <Form.Item
        name="internalKeyName"
        label="Internal Key Name"
        rules={requiredRules}
        className="!mb-3"
      >
        <Input
          placeholder="Enter internal key name"
        />
      </Form.Item>

      {!editForm && (
        <>
          <Form.Item
            name="code"
            label="Code"
            rules={requiredRules}
            className="!mb-3"
          >
            <InputNumber
              controls={false}
              className="!w-full"
              placeholder="Enter internal key code"
            />
          </Form.Item>

          <Form.Item
            name="status"
            label="Status"
            rules={requiredRules}
            className="!mb-3"
          >
            <Select
              placeholder="Select status"
              options={INTERNAL_KEY_STATUS_OPTIONS}
            />
          </Form.Item>
        </>
      )}

      <Form.Item
        name="boxType"
        label="Box"
        className="!mb-3"
      >
        <Select
          placeholder="Select box"
          allowClear
          options={[
            { label: 'Box 1', value: 'Box 1'},
            { label: 'Box 2', value: 'Box 2'},
            { label: 'Box 3', value: 'Box 3'}
          ]}
        />
      </Form.Item>

      <Form.Item
        name="internalKeyType"
        label="Internal Key Type"
        rules={[{
          required: keyType === 'otherKeys',
          message: 'This field is required'
        }]}
        className="!mb-3"
      >
        <Radio.Group>
          {keyType === 'otherKeys'
            ? (
              <>
                <Radio value="Garage">Garage</Radio>
                <Radio value="Office">Office</Radio>
                <Radio value="Other">Other</Radio>
              </>
            )
            : (
              <>
                <Radio value="primary">Primary Key</Radio>
                <Radio value="secondary">Secondary Key</Radio>
              </>
            )}
        </Radio.Group>
      </Form.Item>

      <div className="flex gap-3 justify-end items-end pt-5">
        <Button
          className="hover:!text-buttonTheme hover:!border-buttonTheme"
          onClick={handleCancel}
        >
          Cancel
        </Button>

        <Form.Item
          label={null}
          className="!mb-0"
        >
          <Button
            loading={loading}
            className="bg-buttonTheme hover:!bg-buttonHoverTheme self-end"
            htmlType="submit"
            type='primary'
          >
            {submitButtonLabel}
          </Button>
        </Form.Item>
      </div>
    </Form>
  )
}

export default LockBoxForm
